import React from "react";
import { PasswordInput } from "./PasswordInput";

export const ChangePasswordPage = React.memo(function ChangePassword() {
    return (
        <div className={"change_password_page"}>
            <div className={"container"}>
                <h1 className={"page_title"}>パスワード変更</h1>
                <PasswordInput />
            </div>
        </div>
    );
});
